// extracted by mini-css-extract-plugin
export default {"buttons":"DeletePropertyModal_buttons__U9U6k","errorMessage":"DeletePropertyModal_errorMessage__h-rly"};